import { InfoLabelItem } from 'utils/product-service'
import { ChartSkeletonWrapper, PortfolioChart } from '../../styled'
import React from 'react'
import { useWindowSize } from 'hooks'

import { ALL_PORTFOLIO_ID } from 'app-constants'
import Skeleton from 'react-loading-skeleton'
import { buildPortfolioTooltips } from 'pages/portfolio/services'
import styled from 'styled-components'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { PortfolioPageProps } from 'pages/portfolio/interface'
import { ProductTokenBalance } from 'services/query-v2/users/history/model'

export const ChartWrapper = styled.div``

export const IndexDetails: React.FC<PortfolioPageProps> = ({ portfolioStorage }) => {
  const { selectedProductId, tokenBalances, timeWindow, chartData } = portfolioStorage

  const { isMobile, isTablet } = useWindowSize()
  const isCommon = ![ALL_PORTFOLIO_ID].includes(selectedProductId)
  const isAll = selectedProductId === ALL_PORTFOLIO_ID
  const { run } = useTourGuide()
  const smallDevice = isMobile || isTablet

  const infoList: InfoLabelItem = {
    name: 'Tokens held',
    value: run
      ? '25'
      : tokenBalances
          .find((token: ProductTokenBalance) => token.id === selectedProductId)
          ?.tokens?.toString() ?? '0',
  }

  // TODO add tour back in

  // useEffect(() => {
  //   if (run) {
  //     setChartData(getMockChartData(currentStep < 17))
  //     return
  //   }
  //   setChartData(chart)
  // }, [slowRefresh, interval, currentStep, chart])

  const tooltips = buildPortfolioTooltips(selectedProductId)

  return (
    <div>
      <ChartWrapper>
        {chartData && chartData.arrTimeline.length !== 0 ? (
          <>
            {isCommon && (
              <>
                <PortfolioChart
                  valueHeader={'Invested capital'}
                  insidePadding={isMobile ? 0 : 20}
                  interval={timeWindow}
                  chartData={chartData}
                  tokensHeld={infoList}
                  tooltips={tooltips}
                  portfolioStorage={portfolioStorage}
                />
              </>
            )}
            {isAll && (
              <>
                <PortfolioChart
                  valueHeader={'Invested capital'}
                  insidePadding={isMobile ? 0 : 20}
                  interval={timeWindow}
                  chartData={chartData}
                  tooltips={tooltips}
                  portfolioStorage={portfolioStorage}
                />
              </>
            )}
          </>
        ) : (
          <>
            {smallDevice && (
              <div>
                <Skeleton height={125} borderRadius="1.5rem" />
              </div>
            )}
            <ChartSkeletonWrapper>
              <Skeleton height={382} borderRadius="1.5rem" />
            </ChartSkeletonWrapper>
          </>
        )}
      </ChartWrapper>
    </div>
  )
}
